// extracted by mini-css-extract-plugin
module.exports = {"root":"productTopItem_root__2bWs9","imageContainer":"productTopItem_imageContainer__S_0JG"};